export default function ProblemSolution() {
  return (
    <section className="bg-white py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-3xl overflow-hidden">
          {/* Problem Side */}
          <div className="bg-[#f8f8f6] p-10 md:p-16 flex flex-col justify-center">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 rounded-full bg-red-500" />
              <span className="text-red-500 text-xs font-semibold tracking-widest uppercase" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                The Reality Check
              </span>
            </div>
            <h2
              className="text-[#0A1628] font-black text-3xl md:text-4xl leading-tight mb-10"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Most Businesses Are<br />
              <span className="text-[#0A1628]/50">Losing Money Daily</span>
            </h2>
            <div className="flex flex-col gap-6">
              {[
                "Most businesses still depend on face-to-face sales",
                "No website = lost clients every single day",
                "Competitors online are stealing your customers",
                "Your business is invisible to Google searches",
              ].map((problem, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-red-100 mt-0.5 shrink-0">
                    <i className="ri-close-line text-red-500 text-sm" />
                  </div>
                  <p className="text-[#0A1628]/70 text-base leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {problem}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Solution Side */}
          <div className="bg-[#0A1628] p-10 md:p-16 flex flex-col justify-center relative overflow-hidden">
            <div
              className="absolute inset-0 opacity-5"
              style={{
                backgroundImage:
                  "linear-gradient(#D4AF37 1px, transparent 1px), linear-gradient(90deg, #D4AF37 1px, transparent 1px)",
                backgroundSize: "40px 40px",
              }}
            />
            <div className="relative z-10">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-2 h-2 rounded-full bg-[#D4AF37]" />
                <span className="text-[#D4AF37] text-xs font-semibold tracking-widest uppercase" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  The Web2Revenue Solution
                </span>
              </div>
              <h2
                className="text-white font-black text-3xl md:text-4xl leading-tight mb-8"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                We Create Websites That
                <br />
                <span
                  style={{
                    background: "linear-gradient(135deg, #D4AF37 0%, #f5d980 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  Generate Revenue
                </span>
              </h2>
              <div className="flex flex-col gap-4">
                {[
                  { icon: "ri-smartphone-line", label: "Mobile-First Experience", desc: "90% of clients find you on mobile. We design for them first." },
                  { icon: "ri-robot-line", label: "Automated Client Acquisition", desc: "Your website works 24/7 bringing you leads while you sleep." },
                  { icon: "ri-line-chart-line", label: "Revenue-Focused Design", desc: "Every pixel is designed to convert visitors into paying customers." },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-4 bg-white/5 border border-[#D4AF37]/20 rounded-2xl p-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#D4AF37]/10 shrink-0">
                      <i className={`${item.icon} text-[#D4AF37] text-xl`} />
                    </div>
                    <div>
                      <p className="text-white font-semibold text-sm mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>{item.label}</p>
                      <p className="text-white/50 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
